import { useState } from 'react';
export function useDroppable(onDrop) {
    const [isDraggingOver, setIsDraggingOver] = useState(false);
    const handleDragOver = (event) => {
        event.preventDefault(); // Allows drop
        // onDragOver runs more often than onDragEnter
        // but is necessary since onDragLeave runs when you enter children elements
        setIsDraggingOver(true);
    };
    const handleDrop = (event) => {
        event.preventDefault();
        setIsDraggingOver(false);
        const id = event.dataTransfer.getData('text/plain');
        setTimeout(() => {
            // In case the dragged element is removed instantly, make sure the "onDragEnd" event runs first
            // This ensures that `isDragging` in `useDraggable` is updated to `false` when dropping the item
            onDrop(id);
        }, 1);
    };
    const handleDragLeave = () => {
        setIsDraggingOver(false);
    };
    return {
        isDraggingOver,
        droppableProps: {
            onDragOver: handleDragOver,
            onDrop: handleDrop,
            onDragLeave: handleDragLeave,
        },
    };
}
